<template>
    <div id="scroll-timeline">
        <div class="line"/>
        <div v-for="(tpx, i) in ticksPx" :key="`tick-${i}`" class="tick" :style="{top: tpx}"/>
        <div class="progress" :style="{transform: progressMarkerTransform}"></div>
    </div>
</template>

<script>
import updateOnScroll from 'uos'
import { mapState } from 'vuex'
import { sceneData } from '@/util/sceneMap'

export default {
    data() {
        return {
            progress: 0
        }
    },

    computed: {
        ...mapState(['h']),

        timelineMax() {
            return this.h - 20
        },

        progressMarkerTransform() {
            return `translateY(${this.progress * this.timelineMax}px)`
        },

        ticks() {
            let ticks = []
            for (let scene in sceneData) {
                ticks.push(sceneData[scene].scrollProgress[0])
            }
            ticks.push(1)
            return ticks
        },

        ticksPx() {
            return this.ticks.map(t => t * this.timelineMax + 'px')
        }
    },

    mounted() {
        this.uos = updateOnScroll(0, 1, progress => {
            this.progress = progress
        })
    },

    beforeDestroy() {
        this.uos()
    }
}
</script>

<style lang="stylus" scoped>
#scroll-timeline
    position: fixed
    top: 10px
    bottom: 10px
    right: 10px
    box-sizing: border-box

.line
    position: absolute
    top: 0
    right: -1px
    height: 100%
    border-right: 1px solid white

.progress
    position: absolute
    top: 0
    right: -5px
    width: 15px
    // height: 10px
    // border-radius: 50%
    // background-color: sd-orange
    box-sizing: border-box
    border-top: 4px solid sd-orange

.tick
    position: absolute
    right: 0
    width: 5px
    border-top: 1px solid white
</style>
